<div *ngIf="is24x7; else scheduleTable">24x7</div>

<ng-template #scheduleTable>
    <div class="schedule-table">
        <div class="table-header">
            <div class="header-item">Start Date</div>
            <div class="header-item">Start Time</div>
            <div class="header-item">End Date</div>
            <div class="header-item">End Time</div>
        </div>

        <div class="table-body">
            <div class="table-row" *ngFor="let schedule of parsedDisplayData">
                <div class="row-item">{{ schedule.startdate }}</div>
                <div class="row-item">{{ schedule.starttime }}</div>
                <div class="row-item">{{ schedule.enddate }}</div>
                <div class="row-item">{{ schedule.endtime }}</div>
            </div>
        </div>
    </div>
</ng-template>
